export const HERINNERINGEN_QUERY_KEY = "herinneringen";
